module.exports = {"130524100":"柏乡镇","130524101":"固城店镇","130524102":"西汪镇","130524200":"王家庄乡","130524202":"龙华乡","130524203":"内步乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130524.json
// module id = 123
// module chunks = 0